var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02808 0.538866C9.17364 0.0697824 9.83759 0.0697836 9.98315 0.538867L11.7551 6.249C11.82 6.45822 12.0136 6.60081 12.2326 6.60081H18.014C18.4927 6.60081 18.6977 7.20888 18.3167 7.49875L13.6005 11.0865C13.4333 11.2137 13.3634 11.4319 13.4257 11.6326L15.2177 17.4073C15.3619 17.872 14.8247 18.248 14.4374 17.9534L9.80834 14.4319C9.62946 14.2958 9.38177 14.2958 9.20289 14.4319L4.57379 17.9534C4.18652 18.248 3.64931 17.872 3.79353 17.4073L5.58551 11.6326C5.64778 11.4319 5.57794 11.2137 5.4107 11.0865L0.694543 7.49875C0.313493 7.20888 0.518492 6.60081 0.99727 6.60081H6.7786C6.99766 6.60081 7.19121 6.45822 7.25613 6.249L9.02808 0.538866Z",
    fill: "#FFD15B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.3d8b7b9359efe309dd0a80ee7793bd26.svg";
export { ForwardRef as ReactComponent };